// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"387":"674cd75d","407":"93e95b8c","561":"e35f95c9","993":"2ede28a4"}[chunkId] + ".chunk.js";
};